// extracted by mini-css-extract-plugin
module.exports = {"description":"Description_description__rg4lq","customHTML":"Description_customHTML__2iPB7"};